

const initialState = {
    pickUpStations: [],
    cities:[],
    allCities:[],
    allStates:[]
};


function PickUpStationReducer(state = initialState, action) {


    if (action.type === "PICKUPSTATION_LIST") {
        var pickUpDetailsDetails = {
            ...state,
            pickUpStations: action.payload
        };
        return pickUpDetailsDetails;
    }

    if (action.type === "COUNTRIES_DROPDOWN") {
        var pickUpDetailsDetails = {
            ...state,
            countries: action.payload
        };
        return pickUpDetailsDetails;
    }

    if (action.type === "STATE_DROPDOWN") {
        var pickUpDetailsDetails = {
            ...state,
            allStates: action.payload
        };
        return pickUpDetailsDetails;
    }
    if (action.type === "CITIES_DROPDOWN") {
        var pickUpDetailsDetails = {
            ...state,
            allCities: action.payload
        };
        return pickUpDetailsDetails;
    }


    return state;
}

export default PickUpStationReducer;














